module.exports = __webpack_public_path__ + "media/images/countryrect/kp-3725e0e41aae22f4dc3b5a3ebd9501eb.svg";